import React, { useState } from 'react';
import CountUp from 'react-countup'; // Usamos la librería que ya tienes instalada, plebe
import './Trust.scss';
import { RxPeople } from "react-icons/rx";
import { LiaCertificateSolid } from "react-icons/lia";
import { IoShieldCheckmarkOutline } from "react-icons/io5";
import { PiHeadsetLight } from "react-icons/pi";


export default function Trust() {
  // 1. DATA DE LAS ESTADÍSTICAS
  const statsData = [
    { id: 1, icono: <RxPeople />, prefijo: "+", numero: 500, sufijo: "", titulo: "Empresas atendidas", desc: "en todo México" },
    { id: 2, icono: <LiaCertificateSolid />, prefijo: "", numero: 15, sufijo: "+", titulo: "Años de experiencia", desc: "en el sector contable" },
    { id: 3, icono: <IoShieldCheckmarkOutline />, prefijo: "", numero: 100, sufijo: "%", titulo: "Cumplimiento y confianza", desc: "en cada proceso" },
    { id: 4, icono: <PiHeadsetLight />, prefijo: "", numero: 0, sufijo: "", titulo: "Atención rápida y personalizada", desc: "siempre que lo necesites", esTexto: true }
  ];

  // 2. DATA DEL CARRUSEL de TESTIMONIOS
  const testimoniosData = [
    {
      id: 1,
      texto: "La verdad sí nos quitaron un peso de encima. Ahora ya tenemos mucho más orden con todo lo del SAT y siempre nos apoyan cuando sale alguna duda.",
      nombre: "Brenda",
      foto: "img/brenda.jpg" // Aquí metes la ruta de tu imagen, ej: "img/carlos.jpg"
    },
    {
      id: 2,
      texto: "Yo buscaba un despacho que realmente respondiera y me explicara las cosas sin tanto rollo. Con Zwolf la atención ha sido súper buena desde el inicio.",
      nombre: "Andrea",
      foto: "img/andrea.jpg"
    },
    {
      id: 3,
      texto: "Antes dejaba todo lo fiscal para el final porque se me hacía muy complicado pero ya con Despacho Zwolf siento mucha más tranquilidad y control.",
      nombre: "Jorge",
      foto: "img/jorge.jpg"
    },
    {
      id: 4,
      texto: "Me gusta que todo lo manejan muy práctico y en línea. Nos ahorran muchísimo tiempo y siempre están al pendiente de cualquier tema importante.",
      nombre: "Daniel",
      foto: "img/daniel.jpg"
    }
  ];

  // Lógica del carrusel: Estado para mover los testimonios (en móvil o si son muchos)
  const [currentIndex, setCurrentIndex] = useState(0);

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev === 0 ? testimoniosData.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev === testimoniosData.length - 1 ? 0 : prev + 1));
  };

  return (
    <section className="trust-section">
      {/* ENCABEZADO */}
      <div className="trust-header">
        <span className="trust-subtitle">CONFIANZA</span>
        <h2 className="trust-title">Un despacho en el que puedes confiar</h2>
        <p className="trust-description">
          En Zwolf trabajamos con profesionalismo, transparencia y compromiso <br />
          para brindar tranquilidad a tu empresa.
        </p>
      </div>

      {/* SECCIÓN DE NÚMEROS / ESTADÍSTICAS */}
      <div className="stats-grid">
        {statsData.map((stat) => (
          <div key={stat.id} className="stat-item">
            <div className="stat-icon">{stat.icono}</div>
            <div className="stat-number">
              {stat.esTexto ? (
                <span className="text-large">Atención rápida y personalizada</span>
              ) : (
                <>
                  {stat.prefijo}
                  <CountUp end={stat.numero} duration={2.5} enableScrollSpy />
                  {stat.sufijo}
                </>
              )}
            </div>
            {!stat.esTexto && <h3 className="stat-title">{stat.titulo}</h3>}
            <p className="stat-desc">{stat.desc}</p>
          </div>
        ))}
      </div>

     {/* SECCIÓN DEL CARRUSEL DE TESTIMONIOS */}
      <div className="carousel-container">
        {/* Flecha Izquierda */}
        <button className="carousel-arrow prev" onClick={prevSlide}>
          ←
        </button>

        {/* Ventana que recorta lo que se sale de la pantalla */}
        <div className="carousel-window">
          {/* La cinta que se mueve horizontalmente según el currentIndex */}
          <div 
            className="carousel-track"
            style={{ 
              transform: `translateX(-${currentIndex * (100 / testimoniosData.length)}%)`,
              width: `${testimoniosData.length * 33.33}%` /* Ajusta el ancho según los items */
            }}
          >
            {testimoniosData.map((testimonio) => (
              <div key={testimonio.id} className="testimonial-card">
                <span className="quote-mark">“</span>
                <p className="testimonial-text">{testimonio.texto}</p>
                <div className="user-info">
                  <img src={testimonio.foto} alt={testimonio.nombre} className="user-photo" />
                  <div className="user-text">
                    <h4>{testimonio.nombre}</h4>
                    <p>{testimonio.puesto || "Cliente Zwolf"}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Flecha Derecha */}
        <button className="carousel-arrow next" onClick={nextSlide}>
          →
        </button>
      </div>
    </section>
  );
}